
import { StdResponse, bimAxios } from "@/config/axios"
import { DataBox } from "@/commons/interface/device/data-box";
import { DeviceInstallHistory } from "@/commons/interface/device/sensor";


export function getDataBoxes(projectUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/project/${projectUuid}/data-boxes`, {
        params: {
            ...params,
        }
    })
}

export function getDataBoxDetail(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function createDataBox(data: DataBox, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/data-boxes`, data, {
        params: {
            ...params,
        }
    })
}

export function createDataBoxes(data: DataBox[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/data-boxes/multi`, data, {
        params: {
            ...params,
        }
    })
}

export function updateDataBox(id: number, data: DataBox, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.put(`/data-boxes/${id}`, data, {
        params: {
            ...params,
        }
    })
}

export function deleteDataBoxByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/primitives/${primitiveUuid}/delete-data-box`, {
        params: {
            ...params,
        }
    })
}

export function deleteDataBox(id: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.delete(`/data-boxes/${id}`, {
        params: {
            ...params,
        }
    })
}

export function deleteDataBoxes(data: number[], params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/data-boxes/delete-multi`, data, {
        params: {
            ...params,
        }
    })
}

export function getDataBoxByPrimitiveUuid(primitiveUuid: string, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/primitives/${primitiveUuid}/data-boxes`, {
        params: {
            ...params,
        }
    })
}

export function getDataBoxInstallBySensorId(dataBoxId: number, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.get(`/data-boxs/${dataBoxId}/installs`, {
        params: {
            ...params,
        },
    })
}

export function addDataBoxInstallHistory(projectUuid: string, dataBoxId: number, data: DeviceInstallHistory, params?: {}): Promise<StdResponse<any>> {
    return bimAxios.post(`/projects/${projectUuid}/data-boxs/${dataBoxId}/installs`, data, {
        params: {
            ...params,
        },
    })
}
